import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Alert,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from '../../api/axios';

const ImageUploader = ({ onUploadSuccess, currentImage }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Проверка типа файла
    if (!file.type.startsWith('image/')) {
      setError('Пожалуйста, выберите изображение');
      return;
    }

    // Проверка размера файла (5MB)
    if (file.size > 5 * 1024 * 1024) {
      setError('Размер файла не должен превышать 5MB');
      return;
    }

    setError('');
    setUploading(true);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        const apiUrl = process.env.REACT_APP_API_URL || '/api';
        let baseUrl;
        if (apiUrl.startsWith('http://') || apiUrl.startsWith('https://')) {
          baseUrl = apiUrl.replace('/api', '');
        } else {
          baseUrl = window.location.origin;
        }
        const imageUrl = `${baseUrl}${response.data.url}`;
        onUploadSuccess(imageUrl);
      }
    } catch (error) {
      console.error('Ошибка загрузки изображения:', error);
      setError('Ошибка при загрузке изображения');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box sx={{ my: 2 }}>
      {currentImage && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Текущее изображение:
          </Typography>
          <img
            src={currentImage}
            alt="Current"
            style={{
              maxWidth: '200px',
              maxHeight: '200px',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
        </Box>
      )}

      <input
        accept="image/*"
        style={{ display: 'none' }}
        id="image-upload-input"
        type="file"
        onChange={handleFileChange}
        disabled={uploading}
      />
      <label htmlFor="image-upload-input">
        <Button
          variant="outlined"
          component="span"
          startIcon={uploading ? <CircularProgress size={20} /> : <CloudUploadIcon />}
          disabled={uploading}
        >
          {uploading ? 'Загрузка...' : 'Загрузить изображение'}
        </Button>
      </label>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default ImageUploader;
